/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from '../customModal/customModal.vue';
export default {
    name: "ApprovalModal",
    components: {
        customModal
    },
    props: {
        show: { type: Boolean, default: false },
        context: { type: String, required: true },
        comments: { type: String, default: "" },
        documentId: { type: String, default: "" },
        versionNo: { type: String, default: "" },
        // title: { type: String, default: "QC/Review" }
    },
    emits: ["close", "submit"],
    data() {
        return {
            localComments: "",
            baseUrl: process.env.VUE_APP_Service_URL,
            baseapi: process.env.VUE_APP_Service_URL,
            // title:"QC/Review"
        };
    },
    // mounted() {
      
    //     if(this.context == "approval"){
    //         this.title = "Approve";
    //     }
    //     else if(this.context == "qc"){
    //         this.title = "QC";
    //     }
    //     else if(this.context == "review"){
    //         this.title = "Review";
    //     }
    // },
    computed: {
   
    title() {
      switch (this.context?.toLowerCase()) {
        case "approval":
          return "Approve";
        case "qc":
          return "QC";
        case "review":
          return "Review";
        default:
          return "Action";

      
      }
    },
  },

    methods: {
        async QcReviewSubmit(isApproved) {
            let status = "";
            try {
                this.loading = true;
                if(this.context=="approval"){
                status = isApproved ? "Approved" : "Rejected";
                }
                else if (this.context == "qc"){
                    status = isApproved ? "QCed" : "Rejected";
                }
                else if (this.context == "review"){
                status = isApproved ? "Reviewed" : "Rejected"; 
                }
                const idtoken = store.getters.getIdToken;

                await axios.put(
                    `${this.baseUrl}/etmf/document/approvereject`,
                    {
                        documentId: this.documentId,
                        version: this.versionNo,
                        actionType: this.context.toLowerCase(),
                        approvalStatus: status,
                        comments: this.localComments
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json"
                        }
                    }
                );
                if (this.context.toLowerCase() == "approval") {
                        if(status == "Approved"){
                            alert(`Document approved successfully`);
                        }
                        else if(status == "Rejected"){
                            alert(`Document rejected successfully`);
                        }
                        }
                if (this.context.toLowerCase() == "review") {
                    if(status == "Reviewed") {
                     alert("Document reviewed successfully");
                    }
                    else if(status == "Rejected"){
                        alert("Document review rejected successfully");
                    }
                    
                }
                if (this.context.toLowerCase() == "qc") {
                    if(status == "QCed"){
                        alert("Document QC successfully");

                    }
                    else if(status == "Rejected"){
                        alert("Document QC rejected successfully");
                    }
                    
                }
                this.$emit("saved", { approved: isApproved, status, comments: this.localComments });
                this.$emit("close");
            } catch (error) {
                console.error("Error saving QC/Review status", error);
                alert("Failed to save status");
            } finally {
                this.loading = false;
            }
        },
    }
};